import { useWindowSize } from "@/hooks/utils/useWindowSize";
import { ReduxProvider } from "components/common/ReduxProvider/ReduxProvider";
import { Translate } from "components/common/Translate/Translate";
import { FixedEditorLayout } from "components/modules/Layout/FixedEditorLayout/FixedEditorLayout";
import type { LanguageProps } from "components/modules/Layout/Footer/Footer";
import dynamic from "next/dynamic";
import { AdBottomLeaderboard } from "../../Ads/AdBottomLeaderboard";
import AdsLogicWrapper from "../../Ads/AdsLogicWrapper";
import { ColorHarmonies } from "./EditSettings/ColorHarmonies/ColorHarmonies";
import { ColorVariants } from "./EditSettings/ColorVariants/ColorVariants";
import { ContrastChecker } from "./EditSettings/ContrastChecker/ContrastChecker";

const ColorPickerSettings = dynamic<{}>(() =>
    import("./EditSettings/ColorPickerSettings").then((mod) => mod.ColorPickerSettings),
);
const Preview = dynamic<{}>(() => import("./Preview/Preview").then((mod) => mod.Preview));
const EditorNavbar = dynamic<{ actionButton: null } & LanguageProps>(() =>
    import("components/modules/Navigation/EditorNavbar/EditorNavbar").then((mod) => mod.EditorNavbar),
);

export const ColorPicker = () => {
    const { width } = useWindowSize();
    return (
        <ReduxProvider>
            <>
                <FixedEditorLayout
                    navbar={<EditorNavbar actionButton={null} url="/color-picker" />}
                    action={{
                        desktop: null,
                    }}
                    bottomMenu={<></>}
                    controlBar={null}
                    preview={<Preview />}
                    leftBar={
                        <div className="scroll overflow-y-scroll h-full">
                            <h1
                                className="capitalize text-2xl font-semibold whitespace-nowrap px-4 pt-4"
                                data-testid={`color-picker-title`}
                            >
                                <Translate keyName="title" />
                            </h1>
                            <ColorPickerSettings />
                        </div>
                    }
                    config={{
                        hideBottomAd: true,
                        disableShadow: true,
                    }}
                />
                <div className="hidden lg:block max-w-[840px] mx-auto pt-16 text-black dark:text-white">
                    <ColorVariants />
                </div>
                <div className="hidden lg:block pl-4 max-w-[872px] mx-auto pt-16 text-black dark:text-white">
                    <ColorHarmonies />
                </div>
                <div className="hidden lg:block max-w-[840px] mx-auto pt-16 text-black dark:text-white">
                    <ContrastChecker />
                </div>
                <AdsLogicWrapper>
                    <div
                        className="flex-grow-0 flex-shrink-0 lg:flex items-center justify-center mx-auto mt-28"
                        style={{
                            width: width < 768 ? "320px" : "728px",
                            height: width < 768 ? "50px" : "90px",
                        }}
                    >
                        <AdBottomLeaderboard />
                    </div>
                </AdsLogicWrapper>
            </>
        </ReduxProvider>
    );
};
